<template>
  <div class="mypage-paid-plan-change-edit-page">
    <sub-header-section :pageTitle="$tc('PaidPlanChange.EditPage.title')" :backLink="'/mypage'" />
    <mypage-paid-plan-change-edit-pane />
    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypagePaidPlanChangeEditPane from '@/components/MypagePaidPlanChangePage/MypagePaidPlanChangeEditPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

/**
 * アプリ版: プラン変更(有料=>有料) ページ
 */
export default defineComponent({
  name: 'MypagePaidPlanChangeEditPage',
  components: {
    GlobalNavigationPane,
    SubHeaderSection,
    MypagePaidPlanChangeEditPane,
  },
})
</script>
